import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Link,
  Paper,
  Grid,
  Alert,
  CircularProgress
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Verificar se há uma mensagem de erro na navegação
  useEffect(() => {
    if (location.state?.authError) {
      setError(location.state.authError);
    }
  }, [location.state]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      console.log('Iniciando processo de login...');
      // Usar o contexto de autenticação em vez de chamar diretamente o serviço
      await signIn(formData.email, formData.password);
      console.log('Login bem-sucedido, redirecionando para o dashboard');
      
      // Redirecionar para a página de destino ou dashboard
      const redirectTo = location.state?.from || '/dashboard';
      navigate(redirectTo);
    } catch (error) {
      console.error('Erro durante o login:', error);
      setError(error.message || 'Erro ao fazer login. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        height: '100vh',
        width: '100%',
        margin: 0,
        padding: 0,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&::before': {
          content: '""',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(/background.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.7,
          zIndex: -1
        }
      }}
    >
      <Container component="main" maxWidth="lg" sx={{ m: 0, p: 2 }}>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12} md={6}>
            <Paper elevation={6} sx={{ 
              p: 4, 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              borderRadius: 2
            }}>
              <Typography component="h1" variant="h4" sx={{ mb: 4, color: '#1976d2' }}>
                <b>Sistema TLC</b><br/>Diário Digital da Pessoa Idosa
              </Typography>
              
              {error && (
                <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                  {error}
                </Alert>
              )}

              <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="E-mail"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isLoading}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Senha"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={formData.password}
                  onChange={handleChange}
                  disabled={isLoading}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2, py: 1.5 }}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                      Entrando...
                    </>
                  ) : 'Entrar'}
                </Button>
                <Box sx={{ textAlign: 'center' }}>
                  <Link href="/forgot-password" variant="body2">
                    Esqueci minha senha
                  </Link>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center' }}>
            <img
              src="/elderly-care.png"
              alt="Cuidado com Idosos"
              style={{ maxWidth: '100%', maxHeight: '500px', objectFit: 'cover', borderRadius: '8px' }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Login;
